const isCachedPreview = () => {
  return document.documentElement.hasAttribute("data-turbo-preview");
};
export default isCachedPreview;